import styled from 'styled-components';
import { Button, Text } from '@rsos/components/capstone/base';
import {
  DropdownHeader as Header,
  DropdownFooter as Footer,
  DropdownList as List,
  DropdownListItem as ListItem,
} from '@rsos/components/capstone/base/Dropdown/DropdownComponents';

export const Title = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
  fontWeight: 'semibold',
  lineHeight: '100%',
})``;

export const Subtitle = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
  fontWeight: 'regular',
  lineHeight: '100%',
})`
  opacity: ${p => (p.isDisabled ? 0.4 : 1)};
`;

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  align-items: center;
  position: relative;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  display: flex;
  flex: 0 0 auto;
  margin: 0 20px 0 0;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;

export const ShareButton = styled(Button).attrs({
  btnType: 'primary',
  size: 'med',
  grow: true,
  noMargin: true,
})``;

export const DropdownHeader = styled(Header)`
  padding: 12px 20px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
`;

export const DropdownFooter = styled(Footer)`
  padding: 12px 20px;
`;

export const DropdownList = styled(List)`
  max-height: ${({ breakpoint, layoutWidth }) =>
    layoutWidth <= breakpoint ? '214px' : '400px'};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  overflow-y: auto;
`;

export const DropdownListItem = styled(ListItem)`
  padding: 7px 20px;
  border-radius: 0;
  cursor: default;
`;
